import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const INVOICES_URL = `${API_URL}/invoices`;
const EXPENSES_URL = `${API_URL}/business-expenses`;

const getAuthToken = () => localStorage.getItem('token');

const getHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getAuthToken()}`
  }
});

// ==================== INVOICES ====================

export const createInvoice = async (estimateId, options = {}) => {
  const response = await axios.post(INVOICES_URL, { estimateId, ...options }, getHeaders());
  return response.data;
};

export const fetchInvoices = async (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) queryParams.append(key, value);
  });
  const response = await axios.get(`${INVOICES_URL}?${queryParams.toString()}`, getHeaders());
  return response.data;
};

export const fetchInvoiceById = async (id) => {
  const response = await axios.get(`${INVOICES_URL}/${id}`, getHeaders());
  return response.data;
};

export const updateInvoice = async (id, data) => {
  const response = await axios.put(`${INVOICES_URL}/${id}`, data, getHeaders());
  return response.data;
};

export const sendInvoice = async (id) => {
  const response = await axios.post(`${INVOICES_URL}/${id}/send`, {}, getHeaders());
  return response.data;
};

export const deleteInvoice = async (id) => {
  const response = await axios.delete(`${INVOICES_URL}/${id}`, getHeaders());
  return response.data;
};

export const fetchInvoiceByEstimate = async (estimateId) => {
  const response = await axios.get(`${INVOICES_URL}/by-estimate/${estimateId}`, getHeaders());
  return response.data;
};

// ==================== PAYMENTS ====================

export const recordPayment = async (invoiceId, paymentData) => {
  const response = await axios.post(`${INVOICES_URL}/${invoiceId}/payments`, paymentData, getHeaders());
  return response.data;
};

export const fetchPaymentsByInvoice = async (invoiceId) => {
  const response = await axios.get(`${INVOICES_URL}/${invoiceId}/payments`, getHeaders());
  return response.data;
};

export const updatePayment = async (invoiceId, paymentId, data) => {
  const response = await axios.put(`${INVOICES_URL}/${invoiceId}/payments/${paymentId}`, data, getHeaders());
  return response.data;
};

export const deletePayment = async (invoiceId, paymentId) => {
  const response = await axios.delete(`${INVOICES_URL}/${invoiceId}/payments/${paymentId}`, getHeaders());
  return response.data;
};

export const sendReceipt = async (invoiceId, paymentId) => {
  const response = await axios.post(`${INVOICES_URL}/${invoiceId}/payments/${paymentId}/send-receipt`, {}, getHeaders());
  return response.data;
};

// ==================== BUSINESS EXPENSES ====================

export const createBusinessExpense = async (data) => {
  const response = await axios.post(EXPENSES_URL, data, getHeaders());
  return response.data;
};

export const fetchBusinessExpenses = async (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) queryParams.append(key, value);
  });
  const response = await axios.get(`${EXPENSES_URL}?${queryParams.toString()}`, getHeaders());
  return response.data;
};

export const fetchBusinessExpenseById = async (id) => {
  const response = await axios.get(`${EXPENSES_URL}/${id}`, getHeaders());
  return response.data;
};

export const updateBusinessExpense = async (id, data) => {
  const response = await axios.put(`${EXPENSES_URL}/${id}`, data, getHeaders());
  return response.data;
};

export const deleteBusinessExpense = async (id) => {
  const response = await axios.delete(`${EXPENSES_URL}/${id}`, getHeaders());
  return response.data;
};

export const fetchExpenseSummary = async (params = {}) => {
  const queryParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value) queryParams.append(key, value);
  });
  const response = await axios.get(`${EXPENSES_URL}/summary?${queryParams.toString()}`, getHeaders());
  return response.data;
};
